import { Box, Text } from '@factorialco/deprecated-design-system'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

const ClearFilter = ({ onClearFilters }: { onClearFilters: () => void }) => {
  return (
    <Filter.Base.Chip
      noBorder
      hideChevron
      active={false}
      onClick={onClearFilters}
      label={
        <Box gap="s4" flexDirection="row" alignItems="center">
          <Text.Normal size="200" color="grey800">
            {i18n.t('filters.clear_filters')}
          </Text.Normal>
        </Box>
      }
    />
  )
}

export default ClearFilter
